import { render } from "./CompaniesSparkKz.vue?vue&type=template&id=a6e5a168&scoped=true&ts=true"
import script from "./CompaniesSparkKz.vue?vue&type=script&lang=ts"
export * from "./CompaniesSparkKz.vue?vue&type=script&lang=ts"

import "./CompaniesSparkKz.vue?vue&type=style&index=0&id=a6e5a168&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e5a168"]])

export default __exports__